export default "__VITE_ASSET__DqEARGXW__"